import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from 'react';
import { webSocketService } from '../services/websocket';
const WebSocketContext = createContext(undefined);
export const useWebSocket = () => {
    const context = useContext(WebSocketContext);
    if (context === undefined) {
        throw new Error('useWebSocket must be used within a WebSocketProvider');
    }
    return context;
};
export const WebSocketProvider = ({ children }) => {
    const [isInitialized, setIsInitialized] = useState(false);
    useEffect(() => {
        if (!isInitialized) {
            webSocketService.connect();
            setIsInitialized(true);
        }
    }, [isInitialized]);
    return _jsx(WebSocketContext.Provider, { value: {}, children: children });
};
